import { useTranslation } from 'react-i18next';
import type { Patient } from '@/api/patients/patientsApi.types';
import { RelatedRecordsSection } from '@/components/practitioner/shared/RelatedRecordsSection';
import { IntakeReviewActions } from '@/components/practitioner/shared/IntakeReviewActions';
import { IntakeSubmissionDetails } from '@/components/practitioner/shared/IntakeSubmissionDetails';
import { usePatientIntakeSubmissionQuery } from '@/hooks/useIntake';

interface IntakeReviewSectionProps {
  patientId: string;
  patient: Patient;
}

export function IntakeReviewSection({ patientId, patient }: IntakeReviewSectionProps) {
  const { t } = useTranslation(['intake', 'common']);
  const submissionQuery = usePatientIntakeSubmissionQuery(patientId);

  const submission = submissionQuery.data;
  const hasNoSubmission =
    submissionQuery.isLoading === false &&
    submissionQuery.isError === false &&
    (submission === undefined || submission === null);

  if (hasNoSubmission) {
    return null;
  }

  return (
    <RelatedRecordsSection
      title={t('intake:reviewSection.title')}
      isLoading={submissionQuery.isLoading}
      isError={submissionQuery.isError}
      onRetry={function retry() {
        submissionQuery.refetch();
      }}
      actions={
        submission === undefined || submission === null ? undefined : (
          <IntakeReviewActions submission={submission} />
        )
      }
    >
      {submission === undefined || submission === null ? (
        <p className="text-sm text-zoomuted py-2">{t('intake:reviewSection.empty')}</p>
      ) : (
        <IntakeSubmissionDetails submission={submission} patient={patient} />
      )}
    </RelatedRecordsSection>
  );
}
